/**
 * Get auth token from cookie (authToken).
 * Used for upload workaround: Authorization header instead of credentials to avoid
 * credentialed + wildcard CORS conflict.
 * @returns {string|null} Token or null if not found
 */
export function getAuthToken() {
  const match = document.cookie.match(/authToken=([^;]+)/);
  return match ? decodeURIComponent(match[1].trim()) : null;
}

/**
 * Axios config for file uploads: omit credentials, use Authorization header.
 * TEMPORARY workaround to test if credentialed + wildcard CORS causes upload failures.
 */
export function getUploadConfig() {
  const token = getAuthToken();
  return {
    withCredentials: false,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  };
}
